import { createFileRoute } from '@tanstack/react-router';
import { PipelinePage } from '@/features/tenders';

/** Tenders (appels d'offres): the pipeline of the consultations the office follows. */
export const Route = createFileRoute('/_auth/o/$orgId/tenders/')({
  component: PipelineRoute,
});

function PipelineRoute() {
  const { orgId } = Route.useParams();
  return <PipelinePage orgId={orgId} />;
}
